import React, { Fragment, useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { InfoIcon, XIcon } from 'lucide-react';

export interface HelpSkillsModalProps {
  dialogCloseHandler: () => void;
}


export default function HelpSkillsModal({
  dialogCloseHandler,
}: HelpSkillsModalProps) {

  const [showDialog, setShowDialog] = useState(true);

  const onCloseDialog = () => {
    dialogCloseHandler();
    setShowDialog(false);
  };

  return (
    <Transition.Root show={showDialog} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onCloseDialog}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-customGray" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center m-6 text-left">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="relative flex flex-col rounded-md shadow-xl overflow-hidden p-5 gap-4"
                style={{
                  backgroundColor:'#EFF6FF',
                  width: '80vw',
                  maxWidth: '34.81rem',
                  maxHeight: '90vh',
                    color: '#1D40AE',
                }}
              >
                {/* Header */}
                <div className="flex items-center justify-between flex-none">
                  <h2 className="text-normal font-semibold text-blue-600"
                  >Specialty Skills</h2>
                  <button
                    className="flex items-center justify-center text-gray-700 hover:text-gray-600 transition-colors h-6 w-6"
                    onClick={onCloseDialog}
                  >
                    <XIcon className="w-6 h-6" />
                  </button>
                </div>

                {/* Scrollable Content */}
                <div className="flex flex-row overflow-y-auto gap-3">
                  <div className="inline text-normal text-base w-5 h-5" style={{
                    color: '#3C82F6'
                  }}>
                    <InfoIcon className='w-5 h-5' />
                  </div>

                  <div className="inline text-normal text-base">
                    Select <span className='font-semibold'>up to 10 specialty skills</span> that represent where you operate{' '}
                    <span className='font-semibold'>above the standard expectations of a working stunt professional.</span> {' '}
                    Everyone on FILMIK is already a professional with a solid core skill set. This section isn't about listing everything you can do - it's about highlighting the areas where you're a true specialist, beyond the typical baseline.
                    <br /><br />
                    Specialty skills are grouped by category for easy selection.
                    <br /><br />
                    <span className='font-semibold italic'>2nd Unit/Coordinating • Vehicles • Motorcycles & Bikes • Air & Vertical Risk • Water & Marine • Fire Work • Rigging, Wires & Line Systems • Action Design and Fights • Elite Movement & Body Control • Specializations Beyond Stunts</span>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}